import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "control" }
const _hoisted_2 = { class: "field has-addons" }
const _hoisted_3 = { class: "control is-expanded" }
const _hoisted_4 = ["value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadonlyField',
  props: {
  readonlyValue: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          class: "input",
          type: "text",
          disabled: "",
          value: __props.readonlyValue
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}
}

})